import { useCallback, useState } from "react";
import Modal from "react-modal";

export default function useImageModal() {
  const [imageSource, setImageSource] = useState();
  const [isVisible, setIsVisible] = useState(false);

  const openModal = useCallback(image => {
    setImageSource(image);
    setIsVisible(true);
  }, []);

  const closeModal = useCallback(() => {
    setIsVisible(false);
    setImageSource(null);
  }, []);

  const modal = (
    <Modal
      appElement={document.getElementById("root")}
      isOpen={isVisible}
      className="modalDialogImage"
      overlayClassName="modalOverlay"
      shouldCloseOnEsc={true}
      shouldCloseOnOverlayClick={true}
      onRequestClose={closeModal}
    >
      <img src={imageSource} />
    </Modal>
  );

  return { modal, openModal, closeModal };
}
